import {
  FETCH_BASIC_CONFIG_DATA,
  GET_MASTER_LIST,
  SET_USER_DETAILS,
  GET_MESSAGE_LIBRARY,
  UPDATE_USERS_LIST,
} from "@constants/action";
import {
  fetchBasicConfigSuccess,
  fetchBasicConfigFailure,
  setUserDetailsSuccess,
  getMessageLibrarySuccess,
  getMessageLibraryFailure,
} from "@store/actions/basicConifgAction";
import { getData, postData } from "@services/apiConfig";
import { usermanagement, user, customrolesuam } from "@constants/endpoints";
import { call, put, takeEvery, takeLatest, select } from "redux-saga/effects";
import { useNavigate } from "react-router-dom"; // Import useNavigate

function* fetchBasicConfigAPI(action) {
  try {
    const getObj = action.payload;

    if (getObj.action === "sidebar") {
      let data = null;
      try {
        data = yield call(getData, getObj);
      } catch (e) {
        console.log("error fetching user role data...", e);
      }

      if (getObj.customParams && getObj.customParams.roleName) {
        const roleName = getObj.customParams.roleName;
        const pRoleName = getObj.customParams.pRoleName;
        if (!["HieAdmin", "OrgAdmin", "SuperUser"].includes(roleName)) {
          let uam_data = [],
            default_modules = [];

          try {
            uam_data = yield call(getData, {
              url: `${usermanagement}?rolename=${getObj.customParams.pRoleName}`,
            });
          } catch (e) {
            console.log("error fetching user management data...", e);
          }

          let uDetails = yield select(
            (state) => state.basicConfigReducer?.userdetails || null
          );

          console.log("uDetails>>>>", uDetails.id);

          try {
            default_modules = yield call(getData, {
              url: `${customrolesuam}?rolename=${getObj.customParams.pRoleName}`,
            });
            if (default_modules.length) {
              default_modules = default_modules[0].options;
              /*default_modules = default_modules
                .filter((m) => !m.disable || m.isOther)
                .map((m) => {
                  if (m.label === "Dashboard") {
                    return {
                      ...m,
                      path: m.path+`user?id=${uDetails.id}`,
                    };
                  }
                  return m;
                });*/
              default_modules = default_modules.filter(
                (m) => !m.disable || m.isOther
              );
              console.log("default data fetched:", default_modules);
              if (roleName === "Co-Admin") {
                default_modules = default_modules.filter((m) => m.isCoAdmin);
              }
            }
          } catch (e) {
            console.error("Error fetching default modules data:", e);
          }
          let fData;
          try {
            fData = uam_data
              .filter((o) => o.Role === getObj.customParams.pRoleName)
              .flatMap((p) =>
                p.options.filter(
                  (opt) => opt.label === getObj.customParams.roleName
                )
              );
          } catch (e) {
            try {
              uam_data = yield call(getData, {
                url: `${usermanagement}?rolename=${getObj.customParams.thirdRoleName}`,
              });
            } catch (e) {
              console.log("error fetching user management data...", e);
            }

            fData = uam_data
              .filter((o) => o.Role === getObj.customParams.thirdRoleName)
              .flatMap((p) =>
                p.options.filter(
                  (opt) => opt.label === getObj.customParams.roleName
                )
              );

            default_modules = yield call(getData, {
              url: `${customrolesuam}?rolename=${getObj.customParams.thirdRoleName}`,
            });

            if (default_modules.length) {
              default_modules = default_modules[0].options;
              default_modules = default_modules.filter(
                (m) => !m.disable || m.isOther
              );
              console.log("default data fetched:", default_modules);
              if (roleName === "Co-Admin" || pRoleName === "Co-Admin") {
                default_modules = default_modules.filter((m) => m.isCoAdmin);
              }
            }
          }
          const modulesArray =
            roleName === "Co-Admin" || pRoleName === "Co-Admin"
              ? default_modules
              : default_modules.filter((m) => fData[0].modules.includes(m.key));
          if (modulesArray && modulesArray.length) {
            let isHome = modulesArray.find((m) => m.label === "Home");
            if (!isHome) {
              modulesArray.unshift({
                label: "Home",
                key: "home",
                icon: "HomeOutlined",
                path: "/",
              });
            }
            yield put(fetchBasicConfigSuccess({ sidebarMenu: modulesArray }));
            return;
          }
        }
      }

      if (data) {
        yield put(fetchBasicConfigSuccess({ sidebarMenu: data[0].options }));
      } else {
        console.warn("No data fetched for sidebarMenu.");
      }
    }

    if (getObj.action === "masterList") {
      const data = yield call(getData, getObj);
      yield put(fetchBasicConfigSuccess({ masterList: data }));
    }
  } catch (error) {
    console.error("Error in fetchBasicConfigAPI:", error);
    yield put(fetchBasicConfigFailure(error));
  }
}

function* setUserDetailsAPI(action) {
  const currentPath = window.location.pathname;

  //This is for the routes required before authentication
  if (
    currentPath.includes("registration") ||
    currentPath.includes("set-password") ||
    currentPath.includes("login")
  ) {
    return;
  }

  //This is for the routes required after authentication
  let uDetails = null;
  if (process.env.NODE_ENV === "development") {
    const email = yield select(
      (state) => state.basicConfigReducer?.console?.email || null
    );
    uDetails = email
      ? yield call(getData, {
          url: `${user}?email=${email}`,
        })
      : null;
    uDetails = yield select(
      (state) => state.basicConfigReducer?.userdetails || null
    );
  } else {
    uDetails = yield select(
      (state) => state.basicConfigReducer?.userdetails || null
    );
    // console.log("User details from Redux:", uDetails);

    if (!uDetails) {
      const storedUserDetails = localStorage.getItem("userDetails");

      if (storedUserDetails) {
        // console.log(
        //   "User details from localStorage:",
        //   JSON.parse(storedUserDetails)
        // );
        uDetails = JSON.parse(storedUserDetails);
        localStorage.removeItem("userDetails");
      }
    }
  }

  console.log("User details", uDetails);
  yield put(setUserDetailsSuccess(uDetails));
}

function* getMessageDetailsAPI(action) {
  const getObj = action.payload;
  try {
    const data = yield call(getData, getObj);
    yield put(getMessageLibrarySuccess(data));
  } catch (error) {
    yield put(getMessageLibraryFailure(error)); // Dispatch failure action
  }
}

function* updateUsersListAPI(action) {
  const getObj = action.payload;
  try {
    const data = yield call(postData, getObj);
    console.log(data);
  } catch (error) {
    console.log("Error while updating the users list....", error);
  }
}

export function* basicConfigSaga() {
  yield takeEvery(FETCH_BASIC_CONFIG_DATA, fetchBasicConfigAPI);
  yield takeEvery(GET_MASTER_LIST, fetchBasicConfigAPI);
  yield takeLatest(SET_USER_DETAILS, setUserDetailsAPI);
  yield takeLatest(GET_MESSAGE_LIBRARY, getMessageDetailsAPI);
  yield takeLatest(UPDATE_USERS_LIST, updateUsersListAPI);
}
